<template>
  <div v-if="pictures.length > 1" class="bounty-image-swiper">
    <v-carousel height="auto" show-arrows-on-hover>
      <v-carousel-item v-for="(picture, i) in pictures" :key="i">
        <div class="image">
          <img :src="picture" alt="" />
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
  <div v-else-if="pictures.length === 1">
    <div class="image single">
      <img :src="pictures[0]" alt="" />
    </div>
  </div>
  <div v-else>
    <div class="image blank"></div>
  </div>
</template>

<script>
  export default {
    name: 'BountyImageSwiper',
    props: ['pictures']
  }
</script>

<style scoped lang="scss">
  .bounty-image-swiper {
    ::v-deep .v-carousel__controls {
      height: 20px;
      background: transparent;
    }
    ::v-deep .v-btn {
      &:before {
        content: none;
      }
      i {
        opacity: 1;
      }
    }
    ::v-deep .v-btn--active {
      color: var(--v-primary-base);
      opacity: 1;

    }
    ::v-deep .v-carousel > .v-window__container {
      position: relative !important;
    }
  }
  .v-image ::v-deep .v-image__image {
    background-size: contain;
  }

  .image.single {
    padding-top: 0;

    img {
      position: relative;
      top: auto;
      left: auto;
      height: auto;
    }
  }
</style>
